export default {
    convertRouter(route) {
        let menu = {};
        menu.icon = route.meta.icon;
        menu.title = route.meta.title;
        menu.path = route.path;
        return menu;
    }
}